<template>
    <ac-modal title="Inactivity Logout" ref="modalRef" :size-class="'modal-sm'">
        <template>
            <div class="row">
                <div class="col-xs-12">
                    <p>You will be logged out in {{displayTime}}</p>
                </div>
            </div>  
            <br/>
        </template>
    </ac-modal>
</template>

<script>
    import {common} from "../../global/common.js";

    export default {
        name: "InactivityModal",
        data() {
            return {
                time: 0,
                isModalOpen: false,
                timeLeft: 120,
                displayTime: '2:00',
                countDownStarted: false,
                countDownId: 1,
                timerId: 0
            };
        },
        async mounted() {
            this.activateActivityTracker();
            this.startTimer();
        },
        watch: {
            // whenever time changes, this function will run
            time: function () {
                //modal will show at 13 min displaying 2 min countdown to logout
                if(this.time > 780 && this.isModalOpen == false) {
                    this.showModal();
                }
            },
            timeLeft: function() {
                this.displayCountDown();
                if(this.timeLeft <= 0) {
                    this.logout();
                }
            },
        },
        methods: {
            showModal() {
                this.init();
            },
            init() {
                this.$refs.modalRef.open();
                this.startCountDown();
                this.isModalOpen = true;
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            logout() {
                common.logOut();
            },
            startTimer(){
                let timerId = setInterval(() => {
                    this.time += 1;
                }, 1000);
                this.timerId = timerId;
            },
            startCountDown() {
                if (this.countDownStarted == false) {
                    let countDownId = setInterval(() => {
                        this.timeLeft = this.timeLeft - 1;
                    }, 1000);
                    this.countDownStarted = true;

                    this.countDownId = countDownId;
                }
            },
            displayCountDown() {
                const timeLeft = this.timeLeft;
                const minutes = Math.floor(timeLeft / 60);
                let seconds = timeLeft % 60;

                if (seconds < 10) {
                    seconds = `0${seconds}`;
                }
                this.displayTime = `${minutes}:${seconds}`;
            },
            activateActivityTracker() {
                window.addEventListener("mousemove", this.resetUserActivityTimeout);
                window.addEventListener("scroll", this.resetUserActivityTimeout);
                window.addEventListener("keydown", this.resetUserActivityTimeout);
                window.addEventListener("resize", this.resetUserActivityTimeout);
            },
            resetUserActivityTimeout() {
                clearInterval(this.countDownId);
                clearInterval(this.timerId);
                this.time = 0;
                this.timeLeft = 120;
                this.displayTime = '2:00';
                this.startTimer();

                if(this.isModalOpen) {
                    this.closeModal();
                    this.isModalOpen = false;
                    this.countDownStarted = false;
                }
            },

        }
    }
</script>

<style scoped>

</style>